import React, { useState, useRef } from "react";
import Carousel from "./carousel";
import Benefit from "./benefit";
import Login from "../login/login";

import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBillWave,
  faPaperPlane,
  faMedal,
  faFaceSmile,
} from "@fortawesome/free-solid-svg-icons";

const Landing = () => {
  const toast = useRef(null);

  const [dialog, setDialog] = useState(false);

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="flex flex-column w-full p-0 m-0 landing">
        <div className="flex flex-column  mb-5">
          <div className="flex justify-content-between w-full header">
            <Image src="/prestamosLogo.svg" alt="Image" width="90px" />
            <Button
              className="headerLoginBtn"
              label="Ingresar"
              onClick={() => setDialog(true)}
            />
          </div>
          <Carousel></Carousel>
          <div className="flex justify-content-center align-items-center h-full w-full">
            <div className="flex flex-column justify-content-center align-items-center w-full">
              <h2 className="sectionTitle">
                Créditos inteligentes automatizados
              </h2>
              <p className="sectionSubtitle">
                Iniciá tu nueva experiencia financiera ya.
              </p>
              <div className="flex justify-content-center pt-4">
                <Button
                  className="landingButton"
                  label="Simulá tu crédito"
                  onClick={() => setDialog(true)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full h-1rem border-bottom-1 border-400 mb-6"></div>
        <div className="flex flex-column  mb-5">
          <div className="flex flex-column justify-content-center align-items-center w-full">
            <div className="flex flex-column justify-content-center align-items-center w-full">
              <h2 className="sectionTitle">Nuestra propuesta</h2>
              <p className="sectionSubtitle">
                Cambiamos la forma de pensar las finanzas personales. Usá el
                crédito para sumar y no para restar.
              </p>
              <div className="flex flex-wrap justify-content-around pt-5">
                <Benefit
                  icon={<FontAwesomeIcon icon={faMoneyBillWave} />}
                  title="Tasas más bajas"
                  detail="Diseñamos un sistema distinto, construido en base a la confianza entre organizaciones, sus integrantes y textum."
                />
                <Benefit
                  icon={<FontAwesomeIcon icon={faPaperPlane} />}
                  title="Más rápido"
                  detail="Somos una fintech orientada a la tecnología con foco en procesos automatizados."
                />
                <Benefit
                  icon={<FontAwesomeIcon icon={faMedal} />}
                  title="El mejor respaldo"
                  detail="Creemos en la fortaleza de nuestro equipo. Todas las áreas de nuestra organización están enfocadas en mejorar la calidad de la experiencia de nuestros usuarios."
                />
                <Benefit
                  icon={<FontAwesomeIcon icon={faFaceSmile} />}
                  title="Más humano"
                  detail="Poniendo a las personas y sus organizaciones como centro, diseñamos un ecosistema virtuoso donde la confianza hace la diferencia."
                />
              </div>
              <div>
                <h2 className="sectionTitle">¿Cómo funciona?</h2>
                <div className="flex justify-content-center">
                  <div className="flex justify-content-center w-12">
                    <ol className="row stepsList">
                      <li className="col_md_4 stepCont">
                        <span className="stepNumber">1</span>
                        <span className="stepText">
                          Ingresá a la
                          <span className="stepLink">
                            {" "}
                            calculadora de créditos{" "}
                          </span>{" "}
                          elegí el monto y las cuotas que desees.
                        </span>
                      </li>
                      <li className="col_md_4 stepCont">
                        <span className="stepNumber">2</span>
                        <span className="stepText">
                          Completá tus datos y confirmá tu solicitud.
                        </span>
                      </li>
                      <li className="col_md_4 stepCont">
                        <span className="stepNumber">3</span>
                        <span className="stepText">
                          ¡Te enviaremos un email de confirmación en cuanto
                          aprobemos tu crédito!
                        </span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="flex justify-content-center align-items-center h-full w-full">
                <div className="flex flex-column justify-content-center align-items-center w-full">
                  <h2 className="sectionTitle">¡Comenzá ya!</h2>

                  <div className="flex justify-content-center">
                    <Button
                      className="landingButton"
                      label="Simulá tu crédito"
                      onClick={() => setDialog(true)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="footerSection">
            <ul role="navigation" className="unstyledList footerMenu">
              <li>
                <a className="footerMenuItem" href="/terms">
                  Términos y condiciones
                </a>
              </li>
            </ul>
            <small className="footerCopyright">
              © 2022 textum - Automated credit. Todos los derechos reservados.
            </small>
          </div>
        </footer>
      </div>

      <Dialog
        visible={dialog}
        header="Iniciar sesión"
        modal
        className="flex w-11 sm:w-6 md:w-4"
        onHide={() => {
          setDialog(false);
        }}
      >
        <Login settings={{ toast }} />
      </Dialog>
    </React.Fragment>
  );
};

export default Landing;
